import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "https://apiprov.conduto.com.ec";

const useFormAccessGuard = (idFormularioFromUrl, type) => {
  const navigate = useNavigate();
  const [allowed, setAllowed] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const validateAccess = async () => {
      if (!idFormularioFromUrl || !type) {
        setLoading(false);
        return;
      }

      const pasoDeseado = parseInt(window.location.pathname.split("/").pop());

      try {
        const token = localStorage.getItem("token");

        const resVerificar = await axios.get(
          `${API_URL}/api/formularios/${idFormularioFromUrl}/estado-acceso`,
          {
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true
          }
        );

        if (!resVerificar.data.acceso_permitido) {
          setAllowed(false);
          setLoading(false);
          return;
        }

        const resTipoPersona = await axios.get(
          `${API_URL}/api/providers/active-form`,
          {
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true
          }
        );

        const tipoPersonaBackend = resTipoPersona.data.tipo_persona;

        if (tipoPersonaBackend !== type) {
          console.warn(`Tipo de persona no coincide: URL=${type}, Usuario=${tipoPersonaBackend}`);
          setAllowed(false);
          setLoading(false);
          return;
        }

        const resStep = await axios.get(
          `${API_URL}/api/providers/proveedor-datos/${idFormularioFromUrl}`,
          {
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true
          }
        );

        const currentStepBackend = resStep.data.current_step || 1;

        if (pasoDeseado > currentStepBackend + 1) {
          console.warn(`No puedes saltar al paso ${pasoDeseado} cuando estás en el paso ${currentStepBackend}`);
          setAllowed(false);
          setLoading(false);
          return;
        }

        const resAcceso = await axios.get(`${API_URL}/api/formularios/verificar-acceso`, {
          params: {
            id_formulario: idFormularioFromUrl,
            tipo_persona: tipoPersonaBackend,
            paso: pasoDeseado,
          },
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        });

        setAllowed(resAcceso.data.valido);
      } catch (err) {
        console.error("Acceso denegado:", err);
        setAllowed(false);
      } finally {
        setLoading(false);
      }
    };

    validateAccess();
  }, [idFormularioFromUrl, type, navigate]);

  return { allowed, loading };
};

export default useFormAccessGuard;